import { render, staticRenderFns } from "./WholesaleDetails.vue?vue&type=template&id=6565f8c3&scoped=true"
import script from "./WholesaleDetails.vue?vue&type=script&lang=js"
export * from "./WholesaleDetails.vue?vue&type=script&lang=js"
import style0 from "./WholesaleDetails.vue?vue&type=style&index=0&id=6565f8c3&prod&lang=scss&scoped=true"
import style1 from "./WholesaleDetails.vue?vue&type=style&index=1&id=6565f8c3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6565f8c3",
  null
  
)

export default component.exports